import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Marquee from "@/components/Marquee";
import Hero from "@/sections/Hero";
import About from "@/sections/About";
import Facility from "@/sections/Facility";
import Solutions from "@/sections/Solutions";
import Products from "@/sections/Products";
import Location from "@/sections/Location";
import WhyUjn from "@/sections/WhyUjn";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        e.preventDefault();
        lenis.scrollTo(id, { offset: -72, duration: 1.2 });
      }
    };
    document.addEventListener("click", onClick);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      document.removeEventListener("click", onClick);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="font-body bg-ujn-deep text-ujn-offwhite antialiased">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Facility />
        <Solutions />
        <Marquee />
        <Products />
        <Location />
        <WhyUjn />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
